<div id="cover-spin" [class.spin-visible]="loading"></div>

<div class="maincontainer spinner">
  <div class="search">
    <div class="chips">
      <kion-filter-chips
              [filterChips]="filterChips$ | async"
              (selected)="updateFilter($event)"
      ></kion-filter-chips>
    </div>
    <div class="search-box">
      <kion-search-box
              [value]="searchTerm$ | async"
              [resetValue]="resetValue"
              (searchTriggered)="search($event)"
              (searchBoxResetValue)="searchBoxResetValue()"
              (searchBoxCleared)="searchBoxCleared()"
      ></kion-search-box>
    </div>
  </div>
  <div class="filter-bar">
    <div class="total-results" *ngIf="pagination$ | async as pagination">
      {{ 'order.history.results' | translate : { orders: pagination.total } }}
    </div>
    <div class="sort" *ngIf="orders$ | async as orders">
      <kion-drop-down
              *ngIf="sorts$ | async"
              [title]="'filter.sort.by' | translate"
              [options]="sorts$ | async"
              [showDropDownOnClick]="true"
              [showSelectedOption]="true"
              selectedOptionPosition="behind"
              (selected)="sortChanged($event)"
      ></kion-drop-down>
    </div>
  </div>
  <div class="orderhistorycontainer" *ngIf="orders$ | async as orders">
    <div class="gridcontainer">
      <div class="headline">{{ 'order.history.header.orderNumber' | translate }}</div>
      <div class="headline">{{ 'order.history.header.truck' | translate }}</div>
      <div class="headline">{{ 'order.history.header.purchaseOrderNumber' | translate }}</div>
      <div class="headline">{{ 'order.history.header.purchaseDate' | translate }}</div>
      <div class="headline">{{ 'order.history.header.buyer' | translate }}</div>
      <div class="headline">{{ 'order.history.header.status' | translate }}</div>
    </div>
    <ng-container *ngIf="orders.length > 0; else noOrders">
      <div class="gridcontainer" *ngFor="let order of orders$ | async">
      <div class="ordernumber">{{ order.code }}</div>
      <div class="truck">
        <div class="detail">
          <div class="id">{{ order.device?.serialNumber }}</div>
          <div class="code">{{ order.device?.description }}</div>
        </div>
        <div class="img" *ngIf="order.device?.truckSeries?.images as images; else noImage">
          <img
              *ngIf="images[0] as img"
              [lazyLoad]="img.url + '?width=100&height=57&padColor=fff'"
              [defaultImage]="img.url + '?width=100&height=57&padColor=fff'"
              [errorImage]="'./assets/ui/shared/error/not_found_error_image.png'"
              [alt]="img.altText"
              [title]="img.titleText || img.altText"
              src="#"
              class="device-image"
              width="100%"
              height="100%"
          />
        </div>
        <ng-template #noImage>
          <div class="img">
            <img
              [lazyLoad]="'./assets/ui/shared/error/not_found_error_image.png'"
              [defaultImage]="'./assets/ui/shared/error/not_found_error_image.png'"
              [errorImage]="'./assets/ui/shared/error/not_found_error_image.png'"
              alt="missing_truck"
              title="missing_truck"
              src="#"
              class="device-image"
              width="100px"
              height="100px"
            />
          </div>
        </ng-template>
      </div>
      <div class="purchasenumber">
        {{ order.purchaseOrderNumber }}
      </div>
      <div class="purchasedate">
        <div class="time" *ngIf="order.placed">
          {{ order.placed | date : 'dd.MM.yyyy hh:mm' }}
        </div>
      </div>
      <div class="buyer">{{order.buyer?.firstName}} {{order.buyer?.lastName}}</div>
      <div class="status">
        <kion-status-label
                [class]="order.statusDisplay"
                [text]="'order.history.status.' + order?.statusDisplay?.toLowerCase() | translate">
        </kion-status-label>
      </div>
      <div class="actions">
        <kion-button
                mode="small"
                [isLink]="true"
                [link]="linkDetails + order.id"
                [title]="'order.history.details' | translate"
        ></kion-button>
      </div>
    </div>
    </ng-container>
    <ng-template #noOrders>
      <div class="no-result">{{ 'deviceList.noResult.headline' | translate }}</div>
    </ng-template>
  </div>
</div>
<div class="pagination" *ngIf="(orders$ | async) && (orders$ | async).length > 0">
  <kion-pagination
          *ngIf="pagination$ | async as pagination"
          [totalPages]="pagination.totalPages"
          [currentPage]="pagination.page"
          [defaultPerPageSelected]="pagination.perPage"
          (perPageChanged)="perPageChanged($event)"
          (pageChanged)="pageChanged($event)"
  ></kion-pagination>
</div>
